import { useRef as $lPAwt$useRef, useCallback as $lPAwt$useCallback, useEffect as $lPAwt$useEffect } from "react";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
  var globalListeners = (0, $lPAwt$useRef)(new Map());
  var addGlobalListener = (0, $lPAwt$useCallback)(function (eventTarget, type, listener, options) {
    // Make sure we remove the listener after it is called with the `once` option.
    var fn = (options === null || options === void 0 ? void 0 : options.once) ? function () {
      globalListeners.current.delete(listener);
      listener.apply(void 0, arguments);
    } : listener;
    globalListeners.current.set(listener, {
      type: type,
      eventTarget: eventTarget,
      fn: fn,
      options: options
    });
    eventTarget.addEventListener(type, fn, options);
  }, []);
  var removeGlobalListener = (0, $lPAwt$useCallback)(function (eventTarget, type, listener, options) {
    var _globalListeners_current_get;

    var fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
    eventTarget.removeEventListener(type, fn, options);
    globalListeners.current.delete(listener);
  }, []);
  var removeAllGlobalListeners = (0, $lPAwt$useCallback)(function () {
    globalListeners.current.forEach(function (value, key) {
      removeGlobalListener(value.eventTarget, value.type, key, value.options);
    });
  }, [removeGlobalListener]);
  (0, $lPAwt$useEffect)(function () {
    return removeAllGlobalListeners;
  }, [removeAllGlobalListeners]);
  return {
    addGlobalListener: addGlobalListener,
    removeGlobalListener: removeGlobalListener,
    removeAllGlobalListeners: removeAllGlobalListeners
  };
}

export { $03deb23ff14920c4$export$4eaf04e54aa8eed6 as useGlobalListeners };